import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, toRefs } from 'vue'
import { useStore } from 'vuex'
import { Report } from '@/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataentryStatus',
  props: {
    report: {},
    changestatusreportid: {}
  },
  emits: ['statusreportselected'],
  setup(__props: any, { emit: __emit }) {

const store = useStore()

const props = __props

const emit = __emit
const dynamicRefs = ref<{ [key: string]: HTMLElement | undefined }>({});

const { report, changestatusreportid } = toRefs(props)

const reportstatuslist: string[] = ['Not Acknowledged', 'Acknowledged', 'In Progress', 'Upload Complete'];

const updateReportDataentryStatus = async (payload: { id: string | undefined; status: string }) => {
  await store.dispatch('reports/updateReportDataentryStatus', payload)
}

const changeStatusReport = () => {
  if (report.value?.booking?.cancelled) return
  emit('statusreportselected', report.value.id)
  
  const dropdown = dynamicRefs.value[`destatusdropdown-${report.value.id}`] as any;
  if (dropdown) {
    dropdown.activate();
  }
}

const onSelectReportStatus = async (id: string | undefined, val: string) => {
  await updateReportDataentryStatus({ id, status: val })
  emit('statusreportselected', '')
}

const closeDropdown = () => {
  emit('statusreportselected', '')
}

const statusclass = computed(() => {
  let c = ''
  if (report.value.dataentrystatus === '') {
    c = 'emptystatus'
  } else if (report.value.dataentrystatus === 'Not Acknowledged') {
    c = 'notacknowledged'
  } else if (report.value.dataentrystatus === 'Acknowledged') {
    c = 'acknowledged'
  } else if (report.value.dataentrystatus === 'In Progress') {
    c = 'inprogress'
  } else if (report.value.dataentrystatus === 'Upload Complete') {
    c = 'uploadcomplete'
  }
  return c
})

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", { onFocusout: closeDropdown }, [
    _withDirectives(_createVNode(_component_singleselect_text, {
      class: "statusdtopdown",
      ref: 'destatusdropdown-' + _unref(report).id,
      modelValue: _unref(report).dataentrystatus,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(report).dataentrystatus) = $event)),
      options: reportstatuslist,
      onSelect: _cache[1] || (_cache[1] = ($event: any) => (onSelectReportStatus(_unref(report).id, $event)))
    }, null, 8, ["modelValue"]), [
      [_vShow, _unref(changestatusreportid) === _unref(report).id]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["statustext", statusclass.value]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeStatusReport()))
    }, _toDisplayString(_unref(report).dataentrystatus ? _unref(report).dataentrystatus : 'New'), 3), [
      [_vShow, _unref(changestatusreportid) != _unref(report).id]
    ])
  ], 32))
}
}

})